import './Error.css';

import React from 'react';

import PropTypes from 'prop-types';
import error from '../../imgs/image-error.png';

const ImageError = props => {
  return (
    <div className="image-error">
      <div className="img">
        <img src={error} alt="" />
      </div>
      <div className="title">{props.title}</div>
    </div>
  );
};
ImageError.propTypes = {
  title: PropTypes.string,
};
export default ImageError;
